var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromotionRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17933_18873)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.81,
    r: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 9.81L8.75 7.81L6.75 5.81",
    stroke: "#6A6A6A",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17933_18873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5 0.809998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionRight);
export default __webpack_public_path__ + "static/media/promotion-right.bb4d3ec61326a9ea525aa63013446029.svg";
export { ForwardRef as ReactComponent };